import React from "react";

import AuthTemplate from "../../templates/Auth";
import { Link } from "react-router-dom";

export const PasswordReset = () => {
    return (
        <AuthTemplate>
            <div id="box-send-email">
                <img id="send-email" src={require(`../../assets/images/svgs/send-email.svg`).default} />    
                <h3>E-mail enviado</h3>
                <span>
                    Acesse seu e-mail e clique no link enviado para redefinir sua senha.
                </span>
            </div>
        </AuthTemplate>
    );
}

export default PasswordReset;